import draggable from 'vuedraggable';
import Card from '@/components/TaskCard/TaskCard.vue'
import AddTaskCard from '@/components/AddTaskCard/AddTaskCard.vue'
import { get_token } from "@/router";



export default {
  name: 'Column',
  components: {
    draggable,
    Card,
    AddTaskCard
  },
props: {
  bucket: {
    type: Object,
    required: true
  },
  isNew: {
    type: Boolean,
    default: false
  }
},
  emits: ['update-title', 'add-task', 'delete-bucket'],
  data() {
    return ({
      isEditing: false,
      localTitle: this.bucket?.name || '',
      isAddingTask: false,
      selected_column_id: '',
      showTaskModal: false,
      selected_task: null,
      local_start_date: '',      // Don't access this.selected_task here
      local_due_date: '',
      description: '',
      priority_statuses: [],
      task_statuses: [],
      task_id: null,
      comments: [],
      checklist: [],
      local_task_status_id: '',
      local_priority_status_id: '',
      activeColumnForNewTask: null,
      task_attachments: [],
      buckets:[]
    });
  },
  mounted() {
    this.fetch_task_statuses();
    this.fetch_priority_statuses();
  },
  computed: {
  tasks: {
      get() {
        return this.bucket?.tasks || [];
      },
      set(newTasks) {
        // Emit event to notify parent of changes OR
        // If you can safely modify bucket.tasks, do:
        this.$emit('update:tasks', newTasks); // if using v-model:tasks from parent
        // or
        this.bucket.tasks = newTasks; // only if safe (not recommended)
      }
    },
    checklist_with_placeholder() {
      // If checklist is empty, or the last item has text, add a placeholder
      if (
        this.checklist.length === 0 ||
        (this.checklist[this.checklist.length - 1] &&
          typeof this.checklist[this.checklist.length - 1].text === 'string' &&
          this.checklist[this.checklist.length - 1].text.trim() !== '')
      ) {
        return [...this.checklist, { text: '', is_completed: false }];
      }
      // If the last item is already a blank placeholder, don't add another
      return this.checklist;
    }
},
  methods: {
    getToken() {
                return get_token();
                },
    enableEditing() {
      this.isEditing = true;
      this.$nextTick(() => this.$refs.titleInput?.focus());
    },
    handleTitleSubmit() {
    if (!this.localTitle.trim()) {
      this.isEditing = false;
      return;
    }

    if (this.isNew) {
    this.add_new_column();
    } else {
    this.edit_column();
    }

    this.isEditing = false;
  },
  edit_column(){
        this.isEditing = false;

        $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/update_column/`,
                method: 'POST',
                headers: {
                'Authorization': `Token ${this.getToken()}`,
                'Content-Type': 'application/json'
                },
                data: JSON.stringify({column_id: this.bucket.id,name:this.localTitle}),
                success: (response) => {
                var status = response.status
                if (status == "success") {
                    this.$emit('column-renamed', response.data)
                }

                },

                complete: () => {
                this.isLoading = false;
                }
            });
    },
    startAddingTask(columnId) {

    if (this.isAddingTask && this.selected_column_id === columnId) {
        // If already adding for this column, toggle off
        this.isAddingTask = false;
        this.selected_column_id = null;
      } else {
        // Otherwise, show the form for this column
        this.isAddingTask = true;
        this.selected_column_id = columnId;
      }
    },
    finishAddingTask(newTask) {

      this.bucket.tasks.unshift(newTask);
      this.isAddingTask = false;
      this.selected_column_id = null;
    },
  cancelAddingTask() {
    this.isAddingTask = false;
    this.selected_column_id = null;
  },
open_task_modal(task, bucket) {
  const latest_task = bucket.tasks.find(t => t.id === task.id) || task;
  this.selected_task = latest_task;

  this.task_id = latest_task.id;
  this.local_start_date = latest_task.start_date || '';
  this.local_due_date = latest_task.due_date || '';
  this.local_task_status_id = latest_task.status_id || '';
  this.local_priority_status_id = latest_task.priority_id || '';
  this.description = latest_task.description || '';
  this.comments = Array.isArray(latest_task.comments) ? [...latest_task.comments] : [];
  this.checklist = Array.isArray(latest_task.checklist_items) ? [...latest_task.checklist_items] : [];

  this.fetch_task_files(this.task_id);

  const modal_id = `task_modal_${bucket.id}`;
  this.$nextTick(() => {
    const modal_el = document.getElementById(modal_id);
    if (!modal_el) return;

    const existing = bootstrap.Modal.getInstance(modal_el);
    if (existing) {
      existing.hide();
      existing.dispose();
    }

    const modal = new bootstrap.Modal(modal_el);
    modal.show();
  });
},
set_modal_state(task) {
  this.selected_task = task;
  this.task_id = task.id;

  this.local_start_date = task.start_date || '';
  this.local_due_date = task.due_date || '';
  this.local_task_status_id = task.status_id || '';

  this.local_priority_status_id = task.priority_id || '';
  this.description = task.description || '';

  this.comments = Array.isArray(task.comments) ? [...task.comments] : [];
  this.checklist = Array.isArray(task.checklist_items) ? [...task.checklist_items] : [];
},
  getInitials(name) {
      if (!name || typeof name !== 'string') return '??'; // fallback
      const parts = name.trim().split(' ');
      return parts.map(p => p[0]).join('').toUpperCase().substring(0, 2);
      },
 fetch_task_statuses() {
     $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_task_statuses/`,
          method: 'POST',
          headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
          },
          success: (response) => {
          var status = response.status
          if (status == "success") {
              this.task_statuses = response.data;
          }

          },

          complete: () => {
          this.isLoading = false;
          }
      });

    },
  fetch_priority_statuses() {
    $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_priority_statuses/`,
        method: 'POST',
        headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
        },
        success: (response) => {
            var status = response.status
            if (status == "success") {
                this.priority_statuses = response.data
            }
        }
    });
  },
  update_task(field, value,event) {
       if (event) event.preventDefault();
      const payload = {
        task_id: this.task_id,
      };
      if (field === 'status') payload.progress_id = value;
      if (field === 'priority') payload.priority_id = value;
      if (field === 'start_date') payload.start_date = value;
      if (field === 'due_date') payload.due_date = value;
      if (field === 'description') payload.description = value;

      // Call your API
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/update_task/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(payload),
        success: (response) => {
           const updatedTask = response.data;
      // Update local data so UI reflects changes immediately
          if (field === 'status') {
            this.local_task_status_id = value;
            this.selected_task.status_id = value;
          }
          if (field === 'priority') {
            this.local_priority_status_id = value;
            this.selected_task.priority_id = value;
          }
          if (field === 'start_date') {
            this.local_start_date = value;
            this.selected_task.start_date = value;
          }
          if (field === 'due_date') {
            this.local_due_date = value;
            this.selected_task.due_date = value;
          }
          if (field === 'description') {
            this.selected_task.description = value;
          }

        const taskIndex = this.bucket.tasks.findIndex(t => t.id === updatedTask.id);
        if (taskIndex !== -1) {
          // Use Vue.set if using Vue 2, or direct assignment in Vue 3
          this.bucket.tasks.splice(taskIndex, 1, updatedTask);
        }
        },
        error: (err) => {
          console.error("Error updating a task:", err);
        }
      });

    },
  add_comment() {
      if (!this.comment) return;

      const payload = {
        task_id: this.task_id,
        comment: this.comment
      };

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/post_task_comment/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(payload),
        success: (response) => {
          if (response.status === "success") {
            this.comments.push(response.data);
            this.comment = '';
          }
        },
        error: (err) => {
          console.error("Error adding comment:", err);
        }
      });
    },

submit_checklist_item(item, index) {
    if (!item.text.trim()) return;

    if (item.id) {
      // Edit existing item
      try {

       this.update_checklist_item(item);
      } catch (error) {
        console.error('Error updating item:', error);
      }
    } else {
      // Create new item
      try {
        const newItem = this.createChecklistItem(item.text);
        // Replace the placeholder item with the new item that has an ID
        this.checklist_with_placeholder.splice(index, 1, newItem);
        // Add a new placeholder at the end
        this.checklist_with_placeholder.push({ text: '', is_completed: false });
      } catch (error) {
        console.error('Error creating item:', error);
      }
    }
  },

 createChecklistItem(text) {
      if (!text.trim()) return;

      const payload = {
        task_id: this.task_id,
        text: text,
      };


       $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_checklist_item/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(payload),
        success: (response) => {
          if (response.status === "success") {
            this.checklist.push(response.data);
          }
        },
        error: (err) => {
          console.error("Error adding comment:", err);
        }
      });
    },

update_checklist_item(item) {
    if (!item.text.trim()) return;

    const payload = {
      item_id:item.id,
      is_completed:item.is_completed,
      text: item.text,
    };


      $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/update_checklist_item/`,
      method: 'POST',
      headers: {
        'Authorization': `Token ${this.getToken()}`,
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(payload),
      success: (response) => {
        if (response.status === "success") {
          this.checklist.push(response.data);
          // this.comment = '';
        }
      },
      error: (err) => {
        console.error("Error adding comment:", err);
      }
    });
  },
delete_check_list_item(item,index) {
    const payload = {
      item_id:item.id,
    };


      $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_checklist_item/`,
      method: 'POST',
      headers: {
        'Authorization': `Token ${this.getToken()}`,
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(payload),
      success: () => {
          this.checklist_with_placeholder.splice(index, 1);

      // Ensure there's still an empty placeholder at the end
      const hasPlaceholder = this.checklist_with_placeholder.some(i => !i.id && !i.text.trim());
      if (!hasPlaceholder) {
        this.checklist_with_placeholder.push({ text: '', is_completed: false });
      }
      },
      error: (err) => {
        console.error("Error adding comment:", err);
      }
    });
  },



clear_modal() {
  this.selected_task = null;
  this.task_id = null;
  this.local_start_date = '';
  this.local_due_date = '';
  this.local_task_status_id = '';
  this.local_priority_status_id = '';
  this.description = '';
  this.comments = [];
  this.checklist = [];
  this.showTaskModal = false;
},
onTaskDrop() {
  // Reassign integer positions to all tasks based on new index
  this.bucket.tasks.forEach((task, index) => {
    const newPosition = index + 1;
    if (task.position !== newPosition) {
      this.updateTaskPosition(task.id, this.bucket.id, newPosition);
      task.position = newPosition; // optionally update local state
    }
  });
},
 updateTaskPosition(taskId, columnId, position) {
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/reorder_task/`,
      method: 'POST',
      headers: {
        'Authorization': `Token ${this.getToken()}`,
        'Content-Type': 'application/json'
      },
      data: JSON.stringify({
        task_id: taskId,
        column_id: columnId,
        position: position
      }),
      success: (response) => {
         this.bucket.tasks = response.data.tasks;
      },
      error: (err) => {
        console.error("Error updating task position:", err);
      }
    });
  },
  remove_task(taskId) {
      this.bucket.tasks = this.bucket.tasks.filter(task => task.id !== taskId);
  },
   handleTaskUpdated(updatedTask) {
    const index = this.bucket.tasks.findIndex(t => t.id === updatedTask.id);
    if (index !== -1) {
      this.bucket.tasks.splice(index, 1, updatedTask); // ✅ this triggers reactivity
    }
  },
  handle_file_change(event) {
      const file = event.target.files[0];
      const file_name = file ? file.name : '';
      if (!file) return;



      const formData = new FormData();
      formData.append("file", file);
      formData.append("task_id", this.task_id);
      formData.append("file_name", file_name);
      formData.append("portal_id", this.$route.params.portal_id);
      formData.append("column_id", this.bucket.id);
      formData.append("board_id", this.$route.params.board_id);
      formData.append("portal_name", this.$route.params.portal_name);
      formData.append("task_name", this.selected_task.name);
      formData.append("board_name", this.$route.params.board_name);

       $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_task_attachment/`,
        method: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        headers: {
            'Authorization': `Token ${this.getToken()}`,
        },
        success: (response) => {
            var status = response.status
            if (status == "success") {
                this.task_attachments.push(response.file);
            }
        }
    });
    },

  fetch_task_files(task_id) {
    this.task_attachments = []; // Reset before fetching new files
      $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_task_attachments/`,
            method: 'POST',
            data: JSON.stringify({ task_id: task_id}),
            headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
            },
            success: (response) => {
            var status = response.status
            if (status == "success") {
                this.task_attachments = response.attachments;
            }

            },

            complete: () => {
            this.isLoading = false;
            }
        });

      },
  isImage(fileName) {
    return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(fileName);
  },
  on_drag_change(evt) {
  if (!evt || !evt.added || !evt.added.element) return;

  const task = evt.added.element;
  const to_column_id = this.bucket.id;
  const task_id = task.id;

  this.moveTaskToColumn(task_id, to_column_id);
},
moveTaskToColumn(task_id,column_id) {
      $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/move_task_to_bucket/`,
            method: 'POST',
            data: JSON.stringify({ task_id: task_id ,column_id:column_id}),
            headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
            },
            success: () => {
            this.isLoading = false;

            },

            complete: () => {
            this.isLoading = false;
            }
        });

      },
toggleItem(item) {
    item.is_completed = !item.is_completed;
    if (item.id) {
      this.update_checklist_item(item);
    }
  }
  }
};